export const angularAlexMapDirectiveTemplate = `
<div class="alex-map-angular">
    <div class="map-container" ng-cloack>
        <div class="map" ng-if="map"
                ng-class="{ 'is-fullscreen': map.isFullScreen,
                            'has-sidebar_left': map.sidebarLeft,
                            'has-sidebar_right': map.sidebarRight }">
            <al-map class="map-canvas" id="poiMap" al-center="map.pos"
                        al-layer-preset="map.activePresets">
                        
                <al-layer layer-name="Points-of-interest">
                    <al-feature ng-repeat="p in points track by $index"
                                geometry-type="Point" al-model="p" al-style="pointStyle"
                                label="{{p.name}}">
                    </al-feature>
                </al-layer>
                
                <al-control-container position="top-right">
                    <al-control title="{{localizations.controlTitles.layers}}" al-click="sidebarRight(true)">
                        <i class="material-icons md-24">layers</i>
                    </al-control>
                    <al-control title="{{localizations.controlTitles.fullscreen}}" ng-click="fullscreen(true)"
                                ng-hide="map.isFullScreen">
                        <span class="material-icons md-24">fullscreen</span>
                    </al-control>
                    <al-control title="{{localizations.controlTitles.quitFullscreen}}"
                                ng-click="fullscreen(false)"
                                ng-show="map.isFullScreen">
                        <span class="material-icons md-24">fullscreen_exit</span>
                    </al-control>
                </al-control-container>

                
                <al-control-container position="bottom-right">
                    <al-geolocate-control></al-geolocate-control>
                    <al-zoom-control></al-zoom-control>
                </al-control-container>
            </al-map>
            
            <div class="map-sidebar is-right">
                <header class="map-sidebar_header">
                    <h4 class="map-sidebar_heading">{{localizations.sidebarRight.showOnMap}}</h4>
                    <a class="map-sidebar_close" ng-click="sidebarRight(false)"></a>
                </header>
                <div class="map-sidebar_content">
                <al-layer-sidebar active-presets="map.activePresets"
                                    base-presets="map.basePresets"
                                    addon-presets="map.addonPresets"
                                    vector-layers="map.vectorLayers">
                </div>
            </div>
        </div>
    </div>
</div>`;
